import { Component, Inject, } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserpilotReloader } from '../userpilot-reloader.component';

@Component({
  selector: 'app-flare-dialog',
  templateUrl: './flare-dialog.component.html',
  styleUrls: ['./flare-dialog.component.scss']
})
export class FlareDialogComponent extends UserpilotReloader {
  constructor(public dialogRef: MatDialogRef<FlareDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super();
  }

  confirm() {
    this.dialogRef.close(null);
  }

}
